module.exports = __webpack_public_path__ + "static/media/116.0707c161.svg";